import React from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import { RelateAnswerPayload } from "../RelateAnswerAction.type";
import { DivMarginTop } from "components/common/style/margin/DivMarginTop";
import { useRelateAnswerAction } from "../hook/useRelateAnswerAction";
import AnswerContainLetterView from "./AnswerContainLetterView";

type AnswerCorrectProps = {
  letter: string;
  answer: RelateAnswerPayload;
};

const AnswerCorrect = ({ letter, answer }: AnswerCorrectProps) => {
  const { relateAnswerCorrectSend } = useRelateAnswerAction({});

  const handleSetAsCorrect = () => {
    console.log("handleSetAsCorrect");
    relateAnswerCorrectSend(letter);
  };

  return (
    <Div>
      <DivMarginTop mt={1}>{answer.pronounce}</DivMarginTop>
      <DivMarginTop mt={1}>{answer.meaning}</DivMarginTop>

      {answer.contain.length > 0 && (
        <DivContain>
          {answer.contain.map((containLetter: string) => (
            <div>
              <AnswerContainLetterView letter={containLetter} />
            </div>
          ))}
        </DivContain>
      )}
      <DivOk>
        Set as
        <Button onClick={handleSetAsCorrect}>CORRECT</Button>
      </DivOk>
    </Div>
  );
};

const Div = styled.div`
  margin-top: 1rem;

  div {
    width: 100%;
  }
`;

const DivContain = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const DivOk = styled.div`
  margin-top: 1rem;
`;

export default AnswerCorrect;
